const DAY_MS = 24 * 3600 * 1000

/**
 * How long the connector bucket keeps an import's assets (Bestimage previews, the editor's screenshots and PDFs).
 * It mirrors the bucket's own retention rule, which deletes them, set to 3 days for every connector: change both together.
 */
export const IMPORT_WIZARD_ASSETS_RETENTION_DAYS = 3
export const IMPORT_WIZARD_ASSETS_RETENTION_MS = IMPORT_WIZARD_ASSETS_RETENTION_DAYS * DAY_MS
